import { DateTime } from 'luxon';

export function utcToLocalISO(utc: string, timezone: string): string {
  return DateTime.fromISO(utc, { zone: timezone }).toUTC(0, { keepLocalTime: true }).toISO();
}
